import React from "react";

import { useLocation } from "react-router-dom";
import AccompanimentPage from "./accompanimentPage";
import { useSelector } from "react-redux";
import { canManageMarketingPromotionAnalysis } from "../../../constants/marketingPromotionRoles";
import { isRoleUtil } from "../../../utils/roleAliases";

const AccompanimentCreation = () => {
  const location = useLocation();
  const userData = useSelector((state) => state.userData.userData);

  const accompanimentdata = location.state || {};
  const canManageAnalysis = canManageMarketingPromotionAnalysis(
    userData?.roleList
  );
  const canManageAccompaniment =
    canManageAnalysis ||
    isRoleUtil("ACCOMPANIMENT_LEADER", userData?.roleList) ||
    isRoleUtil("ACCOMPANIMENT_COORDINADOR", userData?.roleList);

  return (
    <AccompanimentPage
      onlyRead={accompanimentdata?.onlyRead || !canManageAccompaniment}
      accompanimentItemId={accompanimentdata?.id || 0}
    />
  );
};

export default AccompanimentCreation;
